// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"46eb0375","655":"46eb0375","885":"46eb0375"}[chunkId] + ".chunk.css";
};